import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-91aaae2a"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "iconfont",
  style: {
    "font-size": "0.4rem",
    "color": "#061c3c"
  }
}, "", -1));
const _hoisted_2 = {
  class: "caodi"
};
const _hoisted_3 = {
  class: "shandui"
};
const _hoisted_4 = {
  class: "sd_tit"
};
const _hoisted_5 = {
  class: "sd_price"
};
const _hoisted_6 = {
  style: {
    "margin": "16px"
  }
};
const _hoisted_7 = {
  key: 0,
  style: {
    "font-size": "14px",
    "color": "red",
    "text-align": "center",
    "margin-bottom": "0.1rem"
  }
};
const _hoisted_8 = {
  class: "shandui",
  style: {
    "min-height": "80vh"
  }
};
const _hoisted_9 = {
  class: "sd_tit"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "0.3rem"
  }
}, null, -1));
const _hoisted_11 = ["title"];
const _hoisted_12 = {
  class: "center_tit"
};
const _hoisted_13 = {
  class: "center_price"
};
const _hoisted_14 = {
  class: "left_text"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "iconfont",
  style: {
    "font-size": "0.3rem",
    "color": "#1ba27a",
    "padding-right": "0.2rem"
  }
}, "", -1));
const _hoisted_16 = {
  class: "left_text"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "iconfont",
  style: {
    "font-size": "0.3rem",
    "color": "coral",
    "padding-right": "0.2rem"
  }
}, "", -1));
const _hoisted_18 = {
  class: "left_text"
};
const _hoisted_19 = {
  class: "content"
};
const _hoisted_20 = {
  class: "shandui",
  style: {
    "box-shadow": "none"
  }
};
const _hoisted_21 = {
  class: "sd_tit"
};
const _hoisted_22 = {
  class: "sd_price"
};
const _hoisted_23 = {
  style: {
    "margin": "16px"
  }
};
const _hoisted_24 = {
  style: {
    "margin-top": "0.3rem",
    "color": "red",
    "font-size": "0.16rem"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_van_nav_bar = _resolveComponent("van-nav-bar");
  const _component_van_field = _resolveComponent("van-field");
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_list = _resolveComponent("van-list");
  const _component_van_tab = _resolveComponent("van-tab");
  const _component_van_tabs = _resolveComponent("van-tabs");
  const _component_Footer = _resolveComponent("Footer");
  const _component_van_action_sheet = _resolveComponent("van-action-sheet");
  const _component_Ce = _resolveComponent("Ce");
  const _component_van_back_top = _resolveComponent("van-back-top");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_van_nav_bar, {
    title: $data.lang.u1,
    onClickLeft: $options.back,
    onClickRight: $options.onClickLeft
  }, {
    left: _withCtx(() => [_createVNode(_component_van_icon, {
      name: "arrow-left",
      color: "#061c3c"
    })]),
    right: _withCtx(() => [_hoisted_1]),
    _: 1
  }, 8, ["title", "onClickLeft", "onClickRight"]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_van_tabs, {
    active: $data.active,
    "onUpdate:active": _cache[4] || (_cache[4] = $event => $data.active = $event),
    ellipsis: false
  }, {
    default: _withCtx(() => [_createVNode(_component_van_tab, {
      title: $data.lang.t10
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString($data.lang.t1), 1), _createElementVNode("div", _hoisted_5, _toDisplayString($data.user.ege), 1), _createVNode(_component_van_field, {
        modelValue: $data.num,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.num = $event),
        "left-icon": "plus",
        type: "digit",
        name: $data.lang.t2,
        label: $data.lang.t2,
        "label-align": "top",
        placeholder: $data.lang.t2,
        rules: [{
          required: true,
          message: $data.lang.t2
        }]
      }, null, 8, ["modelValue", "name", "label", "placeholder", "rules"]), _createVNode(_component_van_field, {
        modelValue: $data.zfpass,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.zfpass = $event),
        "left-icon": "plus",
        type: "password",
        name: $data.lang.t4,
        label: $data.lang.t4,
        "label-align": "top",
        placeholder: $data.lang.t4,
        rules: [{
          required: true,
          message: $data.lang.t4
        }]
      }, null, 8, ["modelValue", "name", "label", "placeholder", "rules"]), _createElementVNode("div", _hoisted_6, [$data.shell.value == 0 ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString($data.lang.tx21), 1)) : _createCommentVNode("", true), _createVNode(_component_van_button, {
        round: "",
        block: "",
        type: "primary",
        class: _normalizeClass($data.shell.value == 0 ? 'jinyong' : ''),
        "native-type": "submit",
        onClick: _cache[2] || (_cache[2] = $event => $options.buy_in()),
        color: "#fd560f"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($data.lang.t6) + " " + _toDisplayString($options.result) + "USDT ", 1)]),
        _: 1
      }, 8, ["class"])])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString($data.lang.t13), 1), _hoisted_10, _createVNode(_component_van_list, {
        loading: $data.loading1,
        "onUpdate:loading": _cache[3] || (_cache[3] = $event => $data.loading1 = $event),
        finished: $data.finished1,
        "finished-text": "No more",
        onLoad: $options.onLoad1
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.list1, item => {
          return _openBlock(), _createElementBlock("div", {
            key: item,
            title: item,
            class: "list_card"
          }, [_createElementVNode("div", _hoisted_12, _toDisplayString($data.lang.t2), 1), _createElementVNode("div", _hoisted_13, _toDisplayString(item.max), 1), _createElementVNode("div", _hoisted_14, [_hoisted_15, _createElementVNode("span", null, _toDisplayString($data.lang.tx1) + "：", 1), _createTextVNode(" +" + _toDisplayString(item.price), 1)]), _createElementVNode("div", _hoisted_16, [_hoisted_17, _createElementVNode("span", null, _toDisplayString($data.lang.tx3) + "：", 1), _createTextVNode(" " + _toDisplayString(item.kou), 1)]), _createElementVNode("div", _hoisted_18, [_createElementVNode("span", null, _toDisplayString($data.lang.tx2) + "：", 1), _createTextVNode(" " + _toDisplayString(item.create_time), 1)])], 8, _hoisted_11);
        }), 128))]),
        _: 1
      }, 8, ["loading", "finished", "onLoad"])])]),
      _: 1
    }, 8, ["title"])]),
    _: 1
  }, 8, ["active"]), _createVNode(_component_Footer, {
    lang_list: $data.lang_list,
    lang: $data.lang
  }, null, 8, ["lang_list", "lang"])]), _createVNode(_component_van_action_sheet, {
    show: $data.show,
    "onUpdate:show": _cache[8] || (_cache[8] = $event => $data.show = $event),
    title: $data.lang.tx13
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, _toDisplayString($data.lang.t1), 1), _createElementVNode("div", _hoisted_22, _toDisplayString($data.user.ege), 1), _createVNode(_component_van_field, {
      modelValue: $data.num1,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.num1 = $event),
      type: "digit",
      name: $data.lang.t2,
      label: $data.lang.t2,
      "label-align": "top",
      placeholder: $data.lang.t2,
      rules: [{
        required: true,
        message: $data.lang.t2
      }]
    }, null, 8, ["modelValue", "name", "label", "placeholder", "rules"]), _createVNode(_component_van_field, {
      modelValue: $data.zfpass,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.zfpass = $event),
      type: "password",
      name: $data.lang.t4,
      label: $data.lang.t4,
      "label-align": "top",
      placeholder: $data.lang.t4,
      rules: [{
        required: true,
        message: $data.lang.t4
      }]
    }, null, 8, ["modelValue", "name", "label", "placeholder", "rules"]), _createElementVNode("div", _hoisted_23, [_createVNode(_component_van_button, {
      round: "",
      block: "",
      type: "primary",
      "native-type": "submit",
      onClick: _cache[7] || (_cache[7] = $event => $options.otc_buy()),
      color: "#061c3c"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString($data.lang.t6) + " " + _toDisplayString($options.result1) + "USDT ", 1)]),
      _: 1
    })]), _createElementVNode("p", _hoisted_24, _toDisplayString($data.lang.tx10) + _toDisplayString($data.buy.kou), 1)])])]),
    _: 1
  }, 8, ["show", "title"]), _createVNode(_component_Ce, {
    lang: $data.lang,
    user: $data.user,
    active: "4"
  }, null, 8, ["lang", "user"]), _createVNode(_component_van_back_top, {
    bottom: "10vh"
  })]);
}